/**
 * A class for interacting with the Bazaarvoice API.
 */
class BazaarvoiceClient {
  /**
   * Creates an instance of the BazaarvoiceAPI class.
   */
  constructor() {
    this.baseUrl = 'https://api.bazaarvoice.com/data'
    this.passKey = __THEME_GLOBALS__.vendor.bazaarVoiceAPIKey
  }

  /**
   * Fetches statistics for the specified product IDs.
   * @param {string[]} productIds - An array of product IDs.
   * @returns {Promise<Object>} A promise that resolves to the statistics data.
   * @throws {Error} If an error occurs during the API request.
   */
  async fetchStatistics(productIds) {
    const params = new URLSearchParams({
      passKey: this.passKey,
      stats: 'NativeReviews',
    })

    params.append('filter', `ProductId:eq:${productIds.join(',')}`)

    const endpoint = `${
      this.baseUrl
    }/statistics.json?apiversion=5.4&${params.toString()}`
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    }

    try {
      const response = await fetch(endpoint, options)
      const data = await response.json()
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  }

  /**
   * Example of other endpoints: (Needs updating according to API docs)
   * Fetches reviews for the specified product ID.
   * @param {string} productId - The ID of the product.
   * @returns {Promise<Object>} A promise that resolves to the reviews data.
   * @throws {Error} If an error occurs during the API request.
   */
  async fetchReviews(productId) {
    const params = new URLSearchParams({
      passKey: this.passKey,
      stats: 'Reviews',
      include: 'Products',
    })

    const endpoint = `${
      this.baseUrl
    }/reviews.json?apiversion=5.4&${params.toString()}&filter=ProductId:eq:${productId}`
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    }

    try {
      const response = await fetch(endpoint, options)
      const data = await response.json()
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  }
}

export { BazaarvoiceClient }
